import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-life-science",
  templateUrl: "./life-science.component.html",
  styleUrls: ["./life-science.component.scss"],
})
export class LifeScienceComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
